import { render } from "./AggregatedExercise.vue?vue&type=template&id=7e9b5fda&ts=true"
import script from "./AggregatedExercise.vue?vue&type=script&lang=ts"
export * from "./AggregatedExercise.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__